<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import CustomersApi from "@/services/customers-api";
import ItemsApi from "@/services/items-api";

export default {
  page: {
    title: "Droits d'acces clients",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      activeTab: 0,
      customersList: [],
      brandsList: [],
      manufacturersList: [],
      brandPageModel: { currentPage: 1, perPage: 10, totalRows: 0, pageSize: 10 },
      carMakePageModel: { currentPage: 1, perPage: 10, totalRows: 0, pageSize: 10 },
      selectedCustomer: null,
      search: "",
      selectedHiddenBrandIds: [],
      selectedHiddenCarMakes: [],
      initialHiddenBrandIds: [],
      initialHiddenCarMakes: [],
      isLoadingCustomers: false,
      isLoadingLists: false,
      isSaving: false,
      brandSearchTimeout: null,
    };
  },
  computed: {
    activeRows() {
      return this.activeTab === 0 ? this.brandRows : this.manufacturerRows;
    },
    brandRows() {
      return this.toRows(this.brandsList, this.selectedHiddenBrandIds);
    },
    manufacturerRows() {
      return this.toRows(this.manufacturersList, this.selectedHiddenCarMakes);
    },
    filteredRows() {
      return this.activeRows;
    },
    allowedCount() {
      return this.activeRows.filter(row => row.allowed).length;
    },
    activePageModel() {
      return this.activeTab === 0 ? this.brandPageModel : this.carMakePageModel;
    },
    hasCustomSettings() {
      return this.selectedHiddenBrandIds.length > 0 || this.selectedHiddenCarMakes.length > 0;
    },
  },
  mounted() {
    this.loadCustomers();
    this.loadLists();
  },
  methods: {
    loadCustomers() {
      this.isLoadingCustomers = true;
          CustomersApi.getCustomers(null,null).then(
            response => {
            this.customersList=response;
            }
        )
        .finally(() => {
          this.isLoadingCustomers = false;
        });
    },

    loadLists() {
      this.isLoadingLists = true;
      Promise.all([
        this.loadBrands(),
        this.loadCarMakes(),
      ]).finally(() => {
        this.isLoadingLists = false;
      });
    },
    loadBrands() {
      return ItemsApi.getBrands(this.brandPageModel.currentPage, this.brandPageModel.perPage, this.search)
        .then(response => {
          if (response) {
            this.brandsList = response.list || [];
            this.brandPageModel.totalRows = response.total || 0;
            this.brandPageModel.currentPage = response.page || this.brandPageModel.currentPage;
            this.brandPageModel.perPage = response.pageSize || this.brandPageModel.perPage;
            this.brandPageModel.pageSize = response.pageSize || this.brandPageModel.perPage;
          }
        });
    },
    loadCarMakes() {
      return ItemsApi.getCarMakes(this.carMakePageModel.currentPage, this.carMakePageModel.perPage, this.search)
        .then(response => {
          if (response) {
            this.manufacturersList = response.list || [];
            this.carMakePageModel.totalRows = response.total || 0;
            this.carMakePageModel.currentPage = response.page || this.carMakePageModel.currentPage;
            this.carMakePageModel.perPage = response.pageSize || this.carMakePageModel.perPage;
            this.carMakePageModel.pageSize = response.pageSize || this.carMakePageModel.perPage;
          }
        });
    },
    refreshCarMakes() {
      if (this.activeTab !== 1) {
        return;
      }
      this.isLoadingLists = true;
      this.loadCarMakes().finally(() => {
        this.isLoadingLists = false;
      });
    },
    searchActiveList() {
      if (this.activeTab === 0) {
        this.searchBrands();
        return;
      }
      this.carMakePageModel.currentPage = 1;
      this.refreshCarMakes();
    },
    refreshActiveList() {
      if (this.activeTab === 0) {
        this.refreshBrands();
        return;
      }
      this.refreshCarMakes();
    },
    refreshBrands() {
      if (this.activeTab !== 0) {
        return;
      }
      this.isLoadingLists = true;
      this.loadBrands().finally(() => {
        this.isLoadingLists = false;
      });
    },
    searchBrands() {
      this.brandPageModel.currentPage = 1;
      this.refreshBrands();
    },
    loadAccessRights() {
      this.search = "";
      this.selectedHiddenBrandIds = [];
      this.selectedHiddenCarMakes = [];
      this.initialHiddenBrandIds = [];
      this.initialHiddenCarMakes = [];

      if (!this.selectedCustomer || !this.selectedCustomer.id) {
        return;
      }

      this.isLoadingLists = true;
      Promise.all([
        CustomersApi.getHiddenBrands(this.selectedCustomer.id),
        CustomersApi.getHiddenCarMakes(this.selectedCustomer.id),
      ]).then(([hiddenBrands, hiddenCarMakes]) => {
        this.selectedHiddenBrandIds = (hiddenBrands || []).map(item => item.id);
        this.selectedHiddenCarMakes = (hiddenCarMakes || []).map(item => item.id);
        this.initialHiddenBrandIds = this.selectedHiddenBrandIds.slice();
        this.initialHiddenCarMakes = this.selectedHiddenCarMakes.slice();
      }).finally(() => {
        this.isLoadingLists = false;
      });
    },
    toRows(list, hiddenIds) {
      return (list || []).map(item => ({
        id: item.id,
        name: item.name,
        allowed: !hiddenIds.includes(item.id),
      }));
    },
    isHidden(row) {
      return this.activeTab === 0
        ? this.selectedHiddenBrandIds.includes(row.id)
        : this.selectedHiddenCarMakes.includes(row.id);
    },
    setHidden(row, hidden) {
      const target = this.activeTab === 0 ? "selectedHiddenBrandIds" : "selectedHiddenCarMakes";
      const ids = this[target].slice();
      const index = ids.indexOf(row.id);

      if (hidden && index === -1) {
        ids.push(row.id);
      }
      if (!hidden && index !== -1) {
        ids.splice(index, 1);
      }

      this[target] = ids;
    },
    allowAll() {
      if (this.activeTab === 0) {
        this.selectedHiddenBrandIds = [];
      } else {
        this.selectedHiddenCarMakes = [];
      }
    },
    denyAll() {
      if (this.activeTab === 0) {
        const pageSize = Math.max(this.brandPageModel.totalRows, this.brandPageModel.perPage, 1);
        this.isLoadingLists = true;
        ItemsApi.getBrands(1, pageSize, this.search)
          .then(response => {
            const brandIds = response && response.list ? response.list.map(item => item.id) : [];
            this.selectedHiddenBrandIds = Array.from(new Set(this.selectedHiddenBrandIds.concat(brandIds)));
          })
          .finally(() => {
            this.isLoadingLists = false;
          });
      } else {
        const pageSize = Math.max(this.carMakePageModel.totalRows, this.carMakePageModel.perPage, 1);
        this.isLoadingLists = true;
        ItemsApi.getCarMakes(1, pageSize, this.search)
          .then(response => {
            const manufacturerIds = response && response.list ? response.list.map(item => item.id) : [];
            this.selectedHiddenCarMakes = Array.from(new Set(this.selectedHiddenCarMakes.concat(manufacturerIds)));
          })
          .finally(() => {
            this.isLoadingLists = false;
          });
      }
    },
    cancelChanges() {
      this.selectedHiddenBrandIds = this.initialHiddenBrandIds.slice();
      this.selectedHiddenCarMakes = this.initialHiddenCarMakes.slice();
    },
    saveAccessRights() {
      if (!this.selectedCustomer || !this.selectedCustomer.id) {
        return;
      }

      this.isSaving = true;
      Promise.all([
        CustomersApi.saveHiddenBrands(this.selectedCustomer.id, this.selectedHiddenBrandIds),
        CustomersApi.saveHiddenCarMakes(this.selectedCustomer.id, this.selectedHiddenCarMakes),
      ]).then(() => {
        this.initialHiddenBrandIds = this.selectedHiddenBrandIds.slice();
        this.initialHiddenCarMakes = this.selectedHiddenCarMakes.slice();
      }).finally(() => {
        this.isSaving = false;
      });
    },
  },
  watch: {
    selectedCustomer() {
      this.loadAccessRights();
    },
    activeTab() {
      this.search = "";
      if (this.activeTab === 0) {
        this.brandPageModel.currentPage = 1;
        this.refreshBrands();
        return;
      }
      this.carMakePageModel.currentPage = 1;
      this.refreshCarMakes();
    },
    search() {
      clearTimeout(this.brandSearchTimeout);
      this.brandSearchTimeout = setTimeout(() => {
        this.searchActiveList();
      }, 300);
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row p-4">
      <div class="col-12">

        <div class="card mb-4">
          <div class="card-body">
            <h2 class="card-title font-size-25 pt-2" style="font-size:2em;">{{ $t('customerAccessRights.title') }}</h2>
            <p class="text-muted mb-4">{{ $t('customerAccessRights.subtitle') }}</p>
            <div class="row align-items-end pb-4">
              <div class="col-lg-5 col-md-12">
                <b-form-group :label="$t('customerAccessRights.client')">
                  <v-select
                    class="style-vselect font-size-16"
                    :options="customersList"
                    :loading="isLoadingCustomers"
                    label="fullCompanyName"
                    v-model="selectedCustomer"
                    :placeholder="$t('customerAccessRights.clientPlaceholder')"
                  >
                    <span slot="no-options">{{ $t('lists.emptyLists.label') }}</span>
                  </v-select>
                </b-form-group>
              </div>
              <div class="col-lg-3 col-md-12 mb-3">
                <b-badge v-if="selectedCustomer && hasCustomSettings" variant="success" class="font-size-13 p-2 ml-2">
                  <i class="fas fa-check-circle mr-1"></i>{{ $t('customerAccessRights.customSettings') }}
                </b-badge>
                <b-badge v-else-if="selectedCustomer" variant="light" class="font-size-13 p-2 ml-2">
                  {{ $t('customerAccessRights.defaultSettings') }}
                </b-badge>
              </div>
              <div class="col-lg-4 col-md-12 text-lg-right">
                <b-button variant="outline-secondary" class="mr-2" :disabled="!selectedCustomer || isSaving" @click="cancelChanges">
                  {{ $t('buttons.cancel') }}
                </b-button>
                <b-button variant="danger" :disabled="!selectedCustomer || isSaving" @click="saveAccessRights">
                  <b-spinner small v-if="isSaving" class="mr-1"></b-spinner>
                  {{ $t('buttons.save') }}
                </b-button>
              </div>
            </div>




            <b-tabs nav-class="nav-tabs-custom" active-nav-item-class="font-weight-bold text-uppercase" content-class="pt-3">

              <b-tab active @click="activeTab = 0">
                <template v-slot:title>
                  <i class="fas fa-industry font-size-16 pr-2"></i>{{ $t('customerAccessRights.brands') }}
                </template>
              </b-tab>
              <b-tab @click="activeTab = 1">
                <template v-slot:title>
                  <i class="fas fa-tags font-size-16 pr-2"></i>{{ $t('customerAccessRights.manufacturers') }}
                </template>
              </b-tab>
            </b-tabs>

            <div class="row align-items-center mb-3">
              <div class="col-lg-4 col-md-12 mb-2 mb-lg-0">
                <b-input-group>
                  <template v-slot:prepend>
                    <b-input-group-text><i class="bx bx-search-alt"></i></b-input-group-text>
                  </template>
                  <b-form-input v-model="search" :placeholder="activeTab === 0 ? $t('customerAccessRights.searchBrand') : $t('customerAccessRights.searchManufacturer')" @keyup.native.enter="searchActiveList" />
                </b-input-group>
              </div>
              <div class="col-lg-8 col-md-12 text-lg-right">
                <b-button variant="outline-success" class="mr-2" :disabled="!selectedCustomer" @click="allowAll">
                  <i class="fas fa-check-circle mr-1"></i>{{ $t('customerAccessRights.allowAll') }}
                </b-button>
                <b-button variant="outline-danger" :disabled="!selectedCustomer" @click="denyAll">
                  <i class="fas fa-ban mr-1"></i>{{ $t('customerAccessRights.denyAll') }}
                </b-button>
              </div>
            </div>

            <div class="table-responsive p-2">
              <table class="table table-centered mb-0">
                <thead class="thead-light">
                  <tr>
                    <th >{{ activeTab === 0 ? $t('customerAccessRights.brand') : $t('customerAccessRights.manufacturer') }}</th>
                    <th class="text-center">{{ $t('customerAccessRights.allowedAccess') }}</th>
                    <th class="text-right">{{ $t('customerAccessRights.actions') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in filteredRows" :key="row.id">
                    <td class="font-weight-bold">{{ row.name }}</td>
                    <td class="text-center">
                      <b-form-checkbox
                        switch
                        size="lg"
                        class="custom-checkbox-success"
                        :checked="!isHidden(row)"
                        :disabled="!selectedCustomer"
                        @change="setHidden(row, !$event)"
                      />
                    </td>
                    <td class="text-right">
                      <b-badge :variant="isHidden(row) ? 'danger' : 'success'" class="font-size-12">
                        {{ isHidden(row) ? $t('customerAccessRights.denied') : $t('customerAccessRights.allowed') }}
                      </b-badge>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="isLoadingLists" class="text-center my-3">
                <b-spinner variant="primary"></b-spinner>
              </div>
              <span v-if="!isLoadingLists && !filteredRows.length" class="d-flex justify-content-center m-4 text-danger">
                {{ $t('customerAccessRights.empty') }}
              </span>
            </div>

            <!-- Pagination -->
            <div class="row pt-3 pl-2 mb-sm-4">
                <div class="col-sm-8">
                    <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                        <b-form-select v-model="activePageModel.perPage" size="sm" style="width: 80px" :options="[10, 15, 50, 100]" @input="searchActiveList"></b-form-select>
                        <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{activePageModel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">
                          <b-pagination
                            v-model="activePageModel.currentPage"
                            :per-page="activePageModel.pageSize"
                            :total-rows="activePageModel.totalRows"
                            :disabled="isLoadingLists"
                            @input="refreshActiveList"
                          ></b-pagination>
                        </ul>
                    </div>
                </div>
            </div> 
            <!-- Fin Pagination  -->


          </div>
        </div>

        <b-alert show variant="info" class="mt-3 mb-0">
          <i class="fas fa-info-circle mr-2"></i>{{ $t('customerAccessRights.help') }}
        </b-alert>
      </div>
    </div>
  </Layout>
</template>